import { useParams } from "react-router-dom";
import NavList from "../../nav/nav-list";
import SiteFooter from "../../custom/site-footer/site-footer";
import FeatureCard from "../../custom/feature-card/feature-card";
import { getProductsByCategory } from "../../../constant/products";
import { CATEGORY_TABS } from "../../../constant/menulist";
import "./category-page-style.scss";

//分類頁
//
//  和首頁共用 NavList（含頂部分類列）—— 切分類是在同一層裡橫移，
//  不是進到下一層，所以不該換成 SubHeader 的「返回 + 標題」。
//
//  版型是一排滿版寬卡而不是首頁那種橫向卡片列：
//  進到分類就是「我要挑一個」，一次看到一張半、往下捲，
//  比一次塞三張小卡更適合比較。
//
//  「哪支產品屬於哪一類」寫在 products.js 的 categories 欄位，
//  這一頁只負責把結果排出來。
const CategoryPage = () => {
  const { key } = useParams();

  const tab = CATEGORY_TABS.find((t) => t.key === key);
  const products = getProductsByCategory(key);

  //FeatureCard 是 5:4 的寬版卡，所以吃 imageWide 而不是直式的卡片圖 ——
  //直式圖塞進寬版框會為了填滿寬度而把上下裁掉，角色的臉正好在上緣，會被切掉。
  const items = products.map((p) => ({
    id: p.id,
    glyph: p.glyph,
    theme: p.theme,
    image: p.imageWide,
    title: p.title,
    subtitle: p.subtitle,
    path: p.path,
  }));

  return (
    <>
      <NavList />

      <main className="cat">
        {items.length > 0 ? (
          <div className="cat__list container">
            {items.map((item) => (
              <FeatureCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          //財運、事業目前還沒有對應的產品。
          //  空狀態要講「還沒有」而不是「找不到」—— 後者會讓人以為是自己點錯了。
          <div className="cat__empty container">
            <p className="cat__empty-mark" aria-hidden="true">閻</p>
            <h2 className="cat__empty-title">
              {tab ? `${tab.label}還沒有開放的服務` : "沒有這個分類"}
            </h2>
            <p className="cat__empty-text">
              閣裡的門還沒全開。先看看「綜合」底下已經在的那幾位。
            </p>
          </div>
        )}
      </main>

      <SiteFooter />
    </>
  );
};

export default CategoryPage;
